import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";

export default class FirstColCellRenderer implements ICellRendererComp {

    private eGui;

    init(params: ICellRendererParams) {
        this.eGui = document.createElement('div');

        const $el = $(this.eGui);
        $el.css({ display: 'flex', 'justify-content': 'space-between', height: '100%', 'align-items': 'center' });
        const $span = $(document.createElement('span'));
        $el.addClass('ag_container_for_hover');
        const groupName = params.valueFormatted ?? params.data?.[params.colDef.field];
        if (groupName)
            $span.text(groupName);
        $el.append($span);

        const $img = $(document.createElement('img'));
        $img.prop('src', '../App_Themes/Standard/Images/CoreTheme/Dashboard/more_dark.svg');
        $img.prop('title', 'more options');
        $img.css({ height: '70%', width: 'auto', cursor: 'pointer' });
        $img.addClass('visibility_hidden');
        $img.click((e) => {
            params.api['contextMenuFactory'].showMenu(params.node, params.column, groupName, e);
        });
        $el.append($img);
    }

    refresh(params: any): boolean {
        return false;
    }

    getGui(): HTMLElement {
        return this.eGui;
    }
}
